export const getLocationHref = () => {
  if (typeof window === 'undefined') {
    return ''
  }

  return window.location.href
}

export const getLocationPathname = () => {
  if (typeof window === 'undefined') {
    return ''
  }

  return window.location.pathname
}

export const getLocationSearch = () => {
  if (typeof window === 'undefined') {
    return ''
  }

  return window.location.search
}

export const navigateTo = (url: string) => {
  if (typeof window !== 'undefined') {
    window.location.href = url
  }
}
